<template>
  <add-mtse-item-table-component
    :value="value"
    id-field="cod_cap_op"
    name="capacidade_maxima_operacao_diaria"
    :validation="validationCategoria"
    @change="onChangeList"
    ref="addItemTableComponent"
  >
    <div class="row d-flex align-items-end form-fields">
      <div class="col-md-4">
        <div class="form-group">
          <label for="categorias">Categoria</label>
          <select
            name="cod_categoria"
            class="form-control"
            id="categorias"
            @change="onChangeCategoria"
          >
            <option value>Selecione</option>
            <option
              v-for="(item, indexCategoria) of categorias"
              :key="indexCategoria"
              :value="item.cod_categoria"
            >{{ item.nome }}</option>
          </select>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label for="especies">Espécies que pretende abater/processar</label>
          <select name="cod_especie" class="form-control" id="especies">
            <option value>Selecione</option>
          </select>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label for="capacidade">Capacidade Abate/Processamento</label>
          <input type="tel" class="form-control numeric" name="capacidade" id="capacidade" />
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label for="codUnidadeMedida">Unidade de medida</label>
          <select name="cod_un_medida" class="form-control" id="codUnidadeMedida">
            <option value>Selecione</option>
            <option
              v-for="(item, indexUnMedida) of unidadesMedida"
              :key="indexUnMedida"
              :value="item.cod_unidade_medida"
            >{{ item.descricao_unidade_medida }}</option>
          </select>
        </div>
      </div>
    </div>
  </add-mtse-item-table-component>
</template>

<script>
export default {
  props: {
    value: {
      required: true,
    },
    categorias: {
      required: true,
    },
    unidadesMedida: {
      required: true,
    },
  },
  methods: {
    validationCategoria(item, list) {
      let isValid = true;
      const itemCategoria = this.categorias.find(
        (el) => el.cod_categoria == item.cod_categoria
      );
      list.forEach((element) => {
        const categoria = this.categorias.find(
          (el) => el.cod_categoria == element.cod_categoria
        );
        if (isValid && categoria.cod_area != itemCategoria.cod_area) {
          this.$toast.error(`Você deve selecionar categorias da mesma área.`);
          isValid = false;
          return;
        }
      });
      return isValid;
    },
    onChangeList(ev) {
      this.$emit("change", ev);
    },
    onChangeCategoria(ev) {
      const val = ev.target.value;
      $("#especies").prop("disabled", true);
      $("#especies").val("");
      $("#capacidade").prop("disabled", false);
      $("#capacidade").val("");
      $("#codUnidadeMedida").prop("disabled", false);
      $("#codUnidadeMedida").val("");

      const categoria = this.categorias.find((el) => el.cod_categoria == val);

      if (categoria && categoria.area == "Armazenagem") {
        $("#capacidade").prop("disabled", true);
        $("#codUnidadeMedida").prop("disabled", true);
      } else if (val) {
        $("#especies").prop("disabled", false);
        $.getJSON(
          "/sie/projeto/especies/estab/" +
            $("#cod_estab").val() +
            "/categoria/" +
            val
        )
          .done(function (json) {
            var options = [];
            options.push('<option value="">Selecione</option>');
            $.each(json, function (key, value) {
              options.push(
                '<option value="' +
                  value.cod_especie +
                  '">' +
                  value.nome_especie +
                  "</option>"
              );
            });
            if (json.length > 0) {
              $("#especies").html(options.join(""));
            } else {
              $("#especies").prop("disabled", true);
            }
          })
          .fail(function (jqxhr, textStatus, error) {
            var err = textStatus + ", " + error;
            console.log("Request Failed: " + err);
          });
      }
    },
  },
  mounted() {
    this.value.forEach((capacidade, index) => {
      $.getJSON(
        "/sie/projeto/especies/estab/" +
          $("#cod_estab").val() +
          "/categoria/" +
          capacidade.cod_categoria
      )
        .done((json) => {
          $.each(json, (key, value) => {
            if (capacidade.cod_especie == value.cod_especie) {
              capacidade.cod_especieSelectValue = value.nome_especie;
              this.$refs["addItemTableComponent"].adjustItemsList();
            }
          });
        })
        .fail((jqxhr, textStatus, error) => {
          var err = textStatus + ", " + error;
          console.log("Request Failed: " + err);
        });
    });
  },
};
</script>
